import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import InvisibleNumber from '@blade/common/components/invisible-number.vue';
import alertDetails from '@blade/common/pages/alert-details/index.vue';
import titleHead from '@blade-sxp/monitor/components/msg/components/title-head.vue';
import imageBox from '@blade-sxp/monitor/components/msg/components/image-box.vue';
import itemRight from '@blade-sxp/monitor/components/msg/components/item-right.vue';
import { AlarmMsgModule } from '@blade-sxp/monitor/store/alarm-msg';
let default_1 = class default_1 extends Vue {
    msgDraw;
    viewMsgList;
    dialogVisible = false;
    details = null;
    detailsType = 'unArrow'; // 不要左右箭头
    maxNum = 99;
    numHeight = 20;
    get recordIds() {
        return this.details?.id;
    }
    get msgList() {
        return AlarmMsgModule.alertList;
    }
    get showMsg() {
        return this.msgList?.length > 0;
    }
    get newViewNow() {
        return this.viewMsgList.length < this.maxNum ? this.viewMsgList.length : this.maxNum;
    }
    get messageSwitch() {
        return AlarmMsgModule.messageSwitch;
    }
    get tipsShow() {
        return AlarmMsgModule.tipsShow;
    }
    get topping() {
        return AlarmMsgModule.topping;
    }
    onMessageSwitchChange(newVal) {
        if (newVal) {
            this.handleViewNow();
        }
        else {
            if (this.viewMsgList.length > 0) {
                AlarmMsgModule.getTipsShow(true);
            }
            else {
                this.handleViewNow();
            }
        }
        this.$emit('changeBadgeShow', newVal);
    }
    onViewMsgListChange(newVal) {
        if (newVal.length > 0) {
            AlarmMsgModule.getTipsShow(true);
        }
    }
    onToppingChange(val) {
        if (val) {
            if (this.messageSwitch) {
                AlarmMsgModule.getTipsShow(false);
            }
        }
    }
    mounted() {
        AlarmMsgModule.getTopping(true);
        AlarmMsgModule.getTipsShow(false);
    }
    updateDetails(val) {
        if (val === 'DELETE') {
            this.$emit('deleteDetails', this.details?.id);
        }
    }
    handleScroll(e) {
        let scrollTop = e?.target?.scrollTop;
        if (scrollTop < this.numHeight) {
            AlarmMsgModule.getTopping(true);
        }
        else {
            AlarmMsgModule.getTopping(false);
        }
    }
    darwClose() {
        this.$emit('darwClose');
    }
    async handleViewNow() {
        AlarmMsgModule.getTipsShow(false);
        await this.$emit('getViewNow');
        if (this.msgList?.length > 0) {
            this.$nextTick(() => {
                this.$refs.msgContent && (this.$refs.msgContent.scrollTop = 0);
            });
        }
    }
    closeDialog(type) {
        if (type === 'jumpPage') {
            this.darwClose();
        }
        this.dialogVisible = false;
    }
    showDialog(item) {
        this.details = {
            ...item,
        };
        this.dialogVisible = true;
    }
    handleAlarmCenter() {
        let newUrl = this.$router.resolve({
            path: '/alarmCenter',
        });
        window.open(newUrl.href, '_blank');
    }
};
__decorate([
    Prop()
], default_1.prototype, "msgDraw", void 0);
__decorate([
    Prop()
], default_1.prototype, "viewMsgList", void 0);
__decorate([
    Watch('messageSwitch')
], default_1.prototype, "onMessageSwitchChange", null);
__decorate([
    Watch('viewMsgList', { immediate: true, deep: true })
], default_1.prototype, "onViewMsgListChange", null);
__decorate([
    Watch('topping')
], default_1.prototype, "onToppingChange", null);
default_1 = __decorate([
    Component({
        name: 'MsgBoard',
        components: {
            InvisibleNumber,
            alertDetails,
            titleHead,
            imageBox,
            itemRight,
        },
        i18n: {
            messages: {
                'en-us': {
                    noData: 'No New Alert',
                    viewAllalerts: 'View All Alerts',
                    textTipsShow: '{num} new notifications，',
                    viewNow: 'view now',
                },
                zh: {
                    noData: '没有新告警',
                    viewAllalerts: '查看更多',
                    textTipsShow: '已接收新的告警 {num} 条，',
                    viewNow: '查看',
                },
            },
        },
    })
], default_1);
export default default_1;
